import {
  type AppManifestBuilder,
  type IHttpClient,
  type TFunction,
  type ExperimentsBag,
} from '@wix/yoshi-flow-editor';
import type { EditorSDK } from '@wix/editor-platform-sdk-types';
import { handleEditFormClick } from '../utils';
import { HELP_ARTICLE_ID } from '../../constants/help';
import { FORM_APP_WIDGET_ID } from '../../constants/app';
import type { ErrorHandlerPublicAPI } from '@wix/fe-essentials-editor/error-handler';
import { type PanoramaClientForComponent } from '@wix/yoshi-flow-editor/build/cjs/exports/panorama';

export const widgetGfppBuilder =
  ({
    t,
    editorSDK,
    appToken,
    httpClient,
    errorHandler,
    panorama,
    getExperiments,
  }: {
    t: TFunction;
    editorSDK: EditorSDK;
    appToken: string;
    httpClient: IHttpClient;
    errorHandler: ErrorHandlerPublicAPI;
    panorama?: PanoramaClientForComponent;
    getExperiments: () => ExperimentsBag;
  }) =>
  async (appManifestBuilder: AppManifestBuilder) =>
    appManifestBuilder.configureWidget(FORM_APP_WIDGET_ID, (widgetBuilder) =>
      widgetBuilder
        .gfpp()
        .set('mainAction1', {
          behavior: 'DEFAULT2',
        })
        .set('mainAction2', {
          behavior: 'DEFAULT1',
        })
        .set('mainAction1', {
          label: t('gfpp_editForm'),
          onClick: ({ detail: { componentRef } }) => {
            panorama?.transaction('open_edit_form_modal').start();
            handleEditFormClick({
              componentRef,
              appToken,
              editorSDK,
              httpClient,
              errorHandler,
              panorama,
            });
          },
        })
        .set('help', { id: HELP_ARTICLE_ID }),
    );
